import { render, staticRenderFns } from "./description.vue?vue&type=template&id=22109310"
import script from "./description.vue?vue&type=script&lang=js"
export * from "./description.vue?vue&type=script&lang=js"
import style0 from "./description.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/description.vue
// module id = 2yNb
// module chunks = 0